// `chave` é o identificador público usado em URLs (ex.: /renovar-licenca?sistema=FINANCEIRO)
export const LISTA_SISTEMAS = [
  { cdsistema: 1, chave: 'SAUTEC', nmsistema: 'Sautec', nmcaminhohome: '/sde', showOnLicenca: true },
  { cdsistema: 2, chave: 'FINANCEIRO', nmsistema: 'Financeiro', nmcaminhohome: '/fin', showOnLicenca: true },
  { cdsistema: 3, chave: 'ADMINISTRATIVO', nmsistema: 'Administrativo', nmcaminhohome: '/adm', showOnLicenca: false },
  { cdsistema: 4, chave: 'SUPORTE', nmsistema: 'Suporte', nmcaminhohome: '/sup', showOnLicenca: false },
];

export const getSistemaPorCodigo = (cdsistema) => LISTA_SISTEMAS.find((s) => s.cdsistema == cdsistema);

export const getSistemaPorChave = (chave) =>
  LISTA_SISTEMAS.find((s) => s.chave === String(chave || '').toUpperCase());

export const getChaveSistema = (cdsistema) => getSistemaPorCodigo(cdsistema)?.chave;
